<form class="p-fluid" [formGroup]="form" (ngSubmit)="submit()">
  <!-- Titel ------------------------------------------------------------ -->
  <div class="form-group">
    <p-floatLabel>
      <input pInputText formControlName="title" id="title" />
      <label for="title">Titel*</label>
    </p-floatLabel>
  </div>

  <!-- Kurs ------------------------------------------------------------- -->
  <div class="form-group" *ngIf="!selectedUser">
    <p-floatLabel>
      <p-dropdown
        formControlName="course"
        [options]="courses"
        optionLabel="courseName"
        optionValue="courseId"
        [filter]="true"
        filterBy="courseName"
        [showClear]="true"
        (onChange)="onCourse($event.value)"
      >
      </p-dropdown>
      <label for="course">Kurs*</label>
    </p-floatLabel>
  </div>

  <!-- Teilnehmer / Interessent ---------------------------------------- -->
  <div class="form-group" *ngIf="!selectedUser">
    <label>
      {{
        form.get("course")?.value === -1
          ? "Interessent:in*"
          : "Kursteilnehmer:in*"
      }}
    </label>

    <p-multiSelect
      formControlName="participant"
      [options]="participants"
      optionLabel="fullName"
      optionValue="userId"
      [filter]="true"
      filterBy="fullName"
      [showToggleAll]="true"
      [virtualScroll]="true"
      [virtualScrollItemSize]="40"
      [showClear]="true"
      [disabled]="disableParticipant"
    >
    </p-multiSelect>

    <p
      *ngIf="form.get('courseId')?.value && participants.length === 0"
      style="margin-top: 5px; color: red; font-style: italic"
    >
      {{
        form.get("courseId")?.value === -1
          ? "Keine Interessent:innen gefunden."
          : "Keine Teilnehmer für diesen Kurs gefunden."
      }}
    </p>
  </div>

  <!-- Notiz ------------------------------------------------------------ -->
  <div class="form-group">
    <label>Notizen</label>
    <p-editor formControlName="text"></p-editor>
  </div>

  <!-- Datei Upload ----------------------------------------------------- -->
  <app-filedrop
    bucketname="notes"
    (fileUploadStarted)="uploadStart()"
    (fileUploadCompleted)="uploadDone($event)"
  >
  </app-filedrop>

  <small class="block">(* Pflichtfelder)</small>

  <!-- Buttons ---------------------------------------------------------- -->
  <div class="form-buttons">
    <button
      pButton
      type="submit"
      label="Speichern"
      icon="pi pi-save"
      class="p-button-success"
      [disabled]="form.invalid || submitting"
    ></button>
    <button
      pButton
      type="button"
      label="Abbrechen"
      icon="pi pi-times"
      class="p-button-secondary"
      (click)="close()"
    ></button>
  </div>
</form>
